export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-line bg-black px-6 py-16 md:px-12">
      <div className="mx-auto max-w-[1600px]">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
          <div>
            <img src="/assets/logo-lockup.png" alt="The Polemikoi Agency" className="h-28 w-auto" />
            <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-500">
              A growth and digital infrastructure agency. Marketing strategy, content creation,
              paid advertising, website development, lead generation, CRM automation, and AI
              business automation — Houston, Texas.
            </p>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            Attention is only valuable when it converts.
          </p>
        </div>
        <div className="mt-12 flex flex-col justify-between gap-4 border-t border-line pt-8 md:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            © {new Date().getFullYear()} The Polemikoi Agency. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-600">
            Strategy / Creative / Technology / Automation
          </p>
        </div>
      </div>
    </footer>
  );
}
